const breakpoints = {
  xs: '599px',
  sm: '959px',
  md: '1279px',
  lg: '1919px',
};

export default breakpoints;
